export const ConceptualLabelScopes = {
    ALL: 'all',
    ORGANIZATION: 'organization',
    SYSTEM: 'system',
}

export const getScopeName = (scope) => {
    switch (scope) {
        case ConceptualLabelScopes.ALL:
            return 'All'
        case ConceptualLabelScopes.ORGANIZATION:
            return 'Organization'
        case ConceptualLabelScopes.SYSTEM:
            return 'System'
    }
}